import { request } from "@/utils/http";
import { Loading } from "element-ui";
let addCart = "/fronted/cart/add";
let cartList = "/fronted/cart/get";
let delCart = "/fronted/cart/delete";
let cartCount = "/fronted/cart/counter";
let editCart = "/fronted/cart/update";
let webPayment = "/fronted/payment/web_params";

export function POST_ADDCART(params) {
  return request(addCart, "post", params);
}
export function GET_CART(params) {
  const loading = Loading.service({ fullscreen: true });
  return request(cartList, "get", params).then(res => {
    loading.close();
    return res;
  });
}
export function POST_DELCART(params) {
  return request(delCart, "post", params);
}
export function POST_CARTCOUNT(params) {
  let headers = { "Content-Type": "application/json" };
  return request(cartCount, "post", params, headers, true, "", true);
}
export function POST_EDITCART(params) {
  return request(editCart, "post", params);
}
export function GET_WEBPAYMENT(params) {
  return request(webPayment, "get", params);
}



// WEBPACK FOOTER //
// ./src/api/cart.api.js